module.exports = __webpack_public_path__ + "static/media/kurikulum.baadf785.png";